import { Field, ID, InputType } from 'type-graphql'
import type { IAction } from '../../action/IAction'
import { ActionArgs } from '../../action/ActionArgs'
import type { Order } from '../../order/Order'

@InputType()
export class CreateReplacementOrderArgs extends ActionArgs {
  @Field(() => ID)
  returnOrderId: string
}

export interface ICreateReplacementOrder extends IAction<Order, CreateReplacementOrderArgs> {}
